<template>
  <editor :id="id" default-tab="event" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import Schedule from './editor/Schedule'
import Clips from './editor/Clips'
import EventWatch from './editor/Watch'
import Form from './editor/Form'
import Tags from './editor/Tags'

export default {
  props: ['id'],
  components: {
    Editor
  },
  data () {
    return {
      tabs: [
        {title: "Event",      name: "event",      component: Form},
        {title: "Schedule",   name: "schedule",   component: Schedule, edit_only: true},
        {title: "Watch",      name: "watch",      component: EventWatch, edit_only: true},
        {title: "Clips",      name: "clips",      component: Clips, edit_only: true},
        {title: "Tags",       name: "tags",       component: Tags, edit_only: true}
      ]
    }
  }
}
</script>
